<div class="skeleton">
  <h2></h2>
</div>
